import { onUnmounted, readonly, ref } from 'vue'

/**
 * Reactive phone-tier detection, mirroring the CSS phone↔tablet boundary.
 *
 * 600px is the same breakpoint used across the patient app — app.css's
 * --screen-pad-x override, LaunchLayout's phone media query, and the native
 * sw600dp split. Keeping this composable pointed at the identical query means
 * JS-driven layout decisions (e.g. teleporting the launch CTA, swapping the
 * full-frog background for the corner crop) flip in lockstep with the CSS,
 * so there's never a frame where the markup and styles disagree.
 */
const PHONE_QUERY = '(max-width: 600px)'

export function useIsPhone() {
  const mql = window.matchMedia(PHONE_QUERY)
  const isPhone = ref(mql.matches)

  const update = (event: MediaQueryListEvent) => {
    isPhone.value = event.matches
  }
  mql.addEventListener('change', update)
  onUnmounted(() => mql.removeEventListener('change', update))

  return { isPhone: readonly(isPhone) }
}
